import { Alert, Flex, Loader, Text } from "@mantine/core";
import { BarDatum, ResponsiveBar } from "@nivo/bar";
import { IconAlertCircle } from "@tabler/icons-react";
import type { EmpresaPorEstado } from "@/routes/relatorio-page/RelatorioLayout";

interface AreaRelatorioEstadoProperties {
  empresasPorEstado: EmpresaPorEstado[];
  loading: boolean;
  error: string | null;
}

const CHART_KEY = "Quantidade de empresas por estado";
// prettier-ignore
const defs = [
  {
    id: "dots",
    type: "patternDots",
    background: "inherit",
    color: "#38bcb2",
    size: 4,
    padding: 1,
    stagger: true
  },
  {
    id: "lines",
    type: "patternLines",
    background: "inherit",
    color: "#eed312",
    rotation: -45,
    lineWidth: 6,
    spacing: 10
  }
]
// prettier-ignore
const fill = [
  {
    match: {
      id: "fries"
    },
    id: "dots"
  },
  {
    match: {
      id: "sandwich"
    },
    id: "lines"
  }
]

const MAGIC_NUMBER = 1.6;

// prettier-ignore
const AreaRelatorioEstado = ({ empresasPorEstado, loading, error }: AreaRelatorioEstadoProperties) => {
  // Mapeia para o formato esperado pelo Nivo chart
  const dataFormatted: BarDatum[] = empresasPorEstado.map(item => ({
    estado: item.estado,
    [CHART_KEY]: item.quantidade
  }));

  if (error) {
    return (
      <Alert icon={<IconAlertCircle size="1rem" />} title="Erro ao carregar dados" color="red">
        {error}
      </Alert>
    );
  }

  return <>
    <Text size={"md"} fw={700}>Quantidade de empresas inscritas por estado</Text>

    {loading ? (
      <Flex h={400} justify="center" align="center">
        <Loader size="lg" />
      </Flex>
    ) : dataFormatted.length === 0 ? (
      <Flex h={400} justify="center" align="center">
        <Text c="dimmed">Nenhum dado disponível para exibir</Text>
      </Flex>
    ) : (
      <Flex h={400} justify="center">
        <ResponsiveBar
        data={dataFormatted}
        keys={[CHART_KEY]}
        indexBy="estado"
        margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
        padding={0.3}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={{ scheme: 'category10' }}
        defs={defs}
        fill={fill}
        borderColor={{
          from: "color",
          modifiers: [
            [
              "darker",
              MAGIC_NUMBER
            ]
          ]
        }}
        axisTop={null}
        axisRight={null}
        colorBy="indexValue"
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: "color",
          modifiers: [
            [
              "darker",
              MAGIC_NUMBER
            ]
          ]
        }}
        role="application"
        ariaLabel="Nivo bar chart demo"
      />
      </Flex>
    )}
  </>

};

export default AreaRelatorioEstado;
